import { render, staticRenderFns } from "./UploadNoteModal.vue?vue&type=template&id=2c7d8b9a"
import script from "./UploadNoteModal.vue?vue&type=script&lang=js"
export * from "./UploadNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports